import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = {
    key: 0,
    class: "font-weight-bold mb-2"
};
const _hoisted_3 = { class: "left-content" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_TreeNode = _resolveComponent("TreeNode");
    const _directive_loading = _resolveDirective("loading");
    return _withDirectives((_openBlock(), _createElementBlock("div", null, [
        (_ctx.componentTree)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_ctx.showHeader)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.tr('viiu.componentMuting.AFFECTED_COMPONENT')), 1))
                    : _createCommentVNode("", true),
                _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_TreeNode, {
                            node: _ctx.componentTree,
                            "should-cascade": _ctx.shouldCascade
                        }, null, 8, ["node", "should-cascade"])
                    ])
                ])
            ]))
            : _createCommentVNode("", true)
    ])), [
        [_directive_loading, _ctx.isLoading]
    ]);
}
